<template>
    <div
        class="o-object-start object-start ui"
        :style="componentStyles"
    >
        <header
            class="object-start-header"
        >
            <AIconButton
                class="back-button"
                :icon="componentParams.back_icon ||  'arrow-left-transparent'"
                :text="$t('ui.back')"
                @onClick="onBack"
            />
            <ACloseIcon />
            <OIntegrationCloseButton/>
        </header>
        <section class="object-start-content-container">
            <h4 class="object-start-title">
                {{ name }}
            </h4>
            <span class="object-content">
                {{ floorName }}
            </span>
        </section>
        <footer class="object-start-footer">
            <AButtonOtg
                :title="$t('ui.start-guide')"
                class="object-start-button object-start-button-start"
                @onClick="onStartGuide"
            />
        </footer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import ACloseIcon from '../../atoms/a-close-icon';
import AButtonOtg from '../../atoms/a-button-otg';
import AIconButton from '../../atoms/a-icon-button';
import { WEB_INTEGRATION } from "../../../utils/constants/route-constants";
import OIntegrationCloseButton from '../../organisms/o-integration-close-button';

export default {
    name: 'OPathStart',
    components: {
        ACloseIcon,
        AButtonOtg,
        AIconButton,
        OIntegrationCloseButton
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getObjectFloorName',
            'getDenormalisedObjectById'
        ]),
        denormalisedObject() {
            return this.getDenormalisedObjectById(Number(this.$route.query.mTo));
        },
        name() {
            return this.t(this.denormalisedObject, 'name') || '';
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPathStart.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.OPathStart.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPathStart.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.OPathStart.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        isShowCustomName() {
            if (this.componentParams.hasOwnProperty('is_show_custom_name')) {
                return this.componentParams.is_show_custom_name
            }
            
            return true
        },
        isShowFloorAndBuilding() {
            if (this.componentParams.hasOwnProperty('is_show_floor_and_building')) {
                return this.componentParams.is_show_floor_and_building
            }
            
            return false
        },
        floorName() {
            return this.getObjectFloorName(this.denormalisedObject, false, this.isShowCustomName, false, this.isShowFloorAndBuilding)
        }
    },
    methods: {
        onBack() {
            this.$router.push({ name: WEB_INTEGRATION.CATALOGUE.LIST.NAME});
        },
        onStartGuide() {
            this.$router.push({ name: WEB_INTEGRATION.CATALOGUE.SETTINGS.NAME, query: { ...this.$route.query } });
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
